import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { InputDisplay } from './input-group.properties';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { BaseInputFieldComponent } from '../base/base-input-field.component';
import { InputFieldType } from '../input-field/input-field.properties';

@Component({
  selector: 'shared-ui-inputs-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.css'],
  standalone: false,
})
export class InputGroupComponent extends BaseInputFieldComponent implements OnInit {
  @Input() display = InputDisplay.Block;
  @Input() showInfo = false;
  @Input() infoPlacement: Placement = 'top';
  @Input() prependElements: TemplateRef<unknown>[] = [];
  @Input() appendElements: TemplateRef<unknown>[] = [];
  @Input() showLabel: boolean = true;
  @Input() type: InputFieldType = InputFieldType.Text;
  @Input() placeholder: string | undefined;
  @Input() maxLen: number = 999;
  @Input() customInput?: TemplateRef<unknown>;
  @ViewChild('myInput') myInput?: ElementRef;
  InputFieldType = InputFieldType;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  isInline(): boolean {
    return this.display === InputDisplay.Inline || this.isJustified();
  }

  isInlineOnly(): boolean {
    return this.display === InputDisplay.Inline;
  }

  isJustified(): boolean {
    return this.display === InputDisplay.InlineSpaced;
  }

  onKeyPress(event: KeyboardEvent): void {
    const allowed = /[0-9+]/;
    const key = event.key;

    if (key === '+' && (event.target as HTMLInputElement).selectionStart !== 0) {
      event.preventDefault();
    }

    if (!allowed.test(key)) {
      event.preventDefault();
    }
  }
}
